<template>
    <div class="PrivatePolicy" v-html="policyData">

    </div>
</template>

<script>
import { getPrivatePolicy } from "@/api/login/index"
export default {
    name: 'ServiceItem',
    data() {
        return {
            // data properties
            policyData: ''
        }
    },
    mounted() {

        this.getPrivatePolicy();
    },
    methods: {
        // methods
        async getPrivatePolicy() {
            let { data: res } = await getPrivatePolicy();
            console.log(res);
            this.policyData = res
            if (!res) return

        }
    }
}
</script>

<style lang="scss" scoped>
.ServiceItem {
    /* styles */
}
</style>